/* eslint-disable */
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  FormControl,
  MenuItem,
  Button,
  IconButton,
  Box,
  Typography,
  Divider,
  makeStyles,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';


const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 0,
    fontFamily: 'Arvo, serif',
  },
  titleBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 3),
  },
  titleText: {
    fontWeight: 600,
    fontSize: 16,
    color: theme.palette.text.primary,
  },
  closeButton: {
    padding: 4,
    color: theme.palette.text.secondary,
  },
  content: {
    padding: theme.spacing(2, 3, 1),
  },
  // Each label + input pair
  fieldGroup: {
    '& + &': {
      marginTop: theme.spacing(2),
    },
  },
  fieldLabel: {
    fontSize: 13,
    fontWeight: 500,
    color: theme.palette.text.secondary,
    marginBottom: 4,
    display: 'block',
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 0,
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 12px',
      fontSize: 14,
    },
  },
  selectControl: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 0,
    },
    '& .MuiSelect-root': {
      padding: '8px 12px',
      fontSize: 14,
    },
  },
  actions: {
    padding: theme.spacing(2, 3),
    justifyContent: 'flex-start',
    borderTop: `1px solid ${theme.palette.divider}`,
    '& > * + *': {
      marginLeft: theme.spacing(1.5),
    },
  },
  cancelButton: {
    color: theme.palette.text.secondary,
    borderColor: theme.palette.text.secondary,
    borderRadius: 0,
    fontWeight: 600,
    textTransform: 'none',
    padding: `${theme.spacing(0.75)}px ${theme.spacing(2.5)}px`,
  },
  saveButton: {
    background: theme.palette.primary.main,
    color: '#fff',
    borderRadius: 0,
    fontWeight: 700,
    textTransform: 'none',
    padding: `${theme.spacing(0.75)}px ${theme.spacing(2.5)}px`,
    '&:hover': {
      background: theme.palette.primary.dark,
    },
  },
}));

const EMPTY = { url: '', displayText: '', title: '', target: '_self' };

export default function QuillLinkDialog({ open, data, onSave, onClose }) {
  const classes = useStyles();
  const [form, setForm] = React.useState(EMPTY);

  React.useEffect(() => {
    if (open) {
      setForm({
        url: (data && data.url) || '',
        displayText: (data && data.displayText) || '',
        title: (data && data.title) || '',
        target: (data && data.target) || '',
      });
    }
  }, [open, data]);

  const set = (field) => (e) => {
    const val = e.target.value;
    setForm((prev) => ({ ...prev, [field]: val }));
  };

  const handleSave = () => {
    if (form.url.trim()) {
      onSave({
        url: form.url.trim(),
        displayText: form.displayText.trim(),
        title: form.title.trim(),
        target: form.target,
      });
    } else {
      onSave(null);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') { e.stopPropagation(); handleSave(); }
    if (e.key === 'Escape') { e.stopPropagation(); onClose(); }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      onKeyDown={handleKeyDown}
      PaperProps={{ className: classes.paper }}
    >
      <Box className={classes.titleBar}>
        <Typography className={classes.titleText}>Insert/Edit Link</Typography>
        <IconButton className={classes.closeButton} onClick={onClose} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <Divider />

      <DialogContent className={classes.content}>
        <Box className={classes.fieldGroup}>
          <Typography component="label" className={classes.fieldLabel}>URL</Typography>
          <TextField
            value={form.url}
            onChange={set('url')}
            variant="outlined"
            size="small"
            fullWidth
            autoFocus
            className={classes.textField}
            inputProps={{ 'aria-label': 'URL' }}
          />
        </Box>

        <Box className={classes.fieldGroup}>
          <Typography component="label" className={classes.fieldLabel}>Text to display</Typography>
          <TextField
            value={form.displayText}
            onChange={set('displayText')}
            variant="outlined"
            size="small"
            fullWidth
            className={classes.textField}
            inputProps={{ 'aria-label': 'Text to display' }}
          />
        </Box>

        <Box className={classes.fieldGroup}>
          <Typography component="label" className={classes.fieldLabel}>Title</Typography>
          <TextField
            value={form.title}
            onChange={set('title')}
            variant="outlined"
            size="small"
            fullWidth
            className={classes.textField}
            inputProps={{ 'aria-label': 'Title' }}
          />
        </Box>

        <Box className={classes.fieldGroup}>
          <Typography component="label" className={classes.fieldLabel}>Open link in...</Typography>
          <FormControl variant="outlined" size="small" fullWidth className={classes.selectControl}>
            <Select
              value={form.target}
              onChange={set('target')}
            >
              <MenuItem value="_self">Current window</MenuItem>
              <MenuItem value="_blank">New window</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions disableSpacing className={classes.actions}>
        <Button variant="outlined" className={classes.cancelButton} onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" className={classes.saveButton} onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
